export default __webpack_public_path__ + "images/0xa19328fb05ce6fd204d16c2a2a98f7cf434c12f4.png";